var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSta5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 80,
    viewBox: "0 0 68 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_704_7329)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.701 80.0001V41.9441L13.3398 43.1223L13.8121 67.2755L32.701 80.0001Z",
    fill: "url(#paint0_radial_704_7329)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7012 41.9441V80.0001L67.4095 72.4596L67.9998 47.4816L32.7012 41.9441Z",
    fill: "url(#paint1_radial_704_7329)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1181 68.9248C14.875 67.2754 14.0486 66.0972 13.8125 64.212V67.2754L32.8194 80V76.4654C32.4653 77.4079 31.0486 77.5257 29.9861 77.0545C26.4444 75.5228 20.1875 71.1634 17.1181 68.9248Z",
    fill: "url(#paint2_radial_704_7329)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7012 76.4654V80L67.4095 72.4595L67.5276 67.3932C67.0553 69.3961 65.9928 70.5743 63.0415 71.8704C57.3748 74.4624 45.5692 77.1723 39.4303 77.7614C36.3609 78.1148 33.1734 77.997 32.7012 76.4654Z",
    fill: "url(#paint3_radial_704_7329)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.459 45.7143V43.2401L32.8201 53.9618V58.5568C31.4034 54.1974 17.1187 44.654 13.459 45.7143Z",
    fill: "url(#paint4_radial_704_7329)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.75
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7012 58.5567C36.0067 52.6657 60.6803 48.4241 67.8817 49.7202L67.9998 47.4816L32.7012 53.2548V58.5567Z",
    fill: "url(#paint5_radial_704_7329)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.701 53.9617L67.8815 47.4816L47.1037 37.2312L13.3398 43.1222L32.701 53.9617Z",
    fill: "url(#paint6_radial_704_7329)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9863 51.2518L67.8822 47.4816L47.1044 37.2312L46.9863 37.8203V51.2518Z",
    fill: "url(#paint7_radial_704_7329)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9848 37.8203L66.2279 47.2459L32.8181 53.3726L14.9918 43.4757L46.9848 37.8203ZM47.1029 37.2312L13.457 43.1222L32.8181 53.8439L68.1168 47.3637L47.1029 37.2312Z",
    fill: "url(#paint8_linear_704_7329)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5547 74.5803L28.5686 51.6054L27.1519 50.8984L19.2422 70.9279L24.5547 74.5803Z",
    fill: "url(#paint9_linear_704_7329)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_704_7329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 29,
    width: 53,
    height: 25
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9922 43.4757L32.8186 53.3726L66.2283 47.246V29.2195H14.9922V43.4757Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_704_7329)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8396 42.651C39.1938 44.3005 37.7771 46.3035 35.298 47.246C32.9368 48.1886 30.4577 47.7173 29.6313 46.1856C29.3952 45.8322 29.2771 45.4787 29.041 45.0074L33.7632 43.1223L38.4855 41.2372C38.6035 41.8263 38.7216 42.2976 38.8396 42.651Z",
    fill: "url(#paint10_linear_704_7329)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4863 43.1222C38.7224 44.3005 37.778 45.8321 36.2433 46.6569C34.7086 47.4816 33.0558 47.3638 32.4655 46.3034C32.3474 46.0678 32.2294 45.8321 32.1113 45.4787L35.1808 43.8292L38.2502 42.1797C38.2502 42.5331 38.3683 42.7688 38.4863 43.1222Z",
    fill: "url(#paint11_radial_704_7329)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6035 43.1223C38.9577 44.5361 37.6591 46.3034 35.6521 47.246C33.7632 48.0707 31.7563 47.8351 30.9299 46.7747C29.9855 46.5391 29.3952 45.9499 29.041 45.1252C29.2771 45.5965 29.3952 45.9499 29.6313 46.3034C30.4577 47.8351 32.9368 48.3064 35.298 47.3638C37.6591 46.4212 39.1938 44.4183 38.8396 42.7688C38.7216 42.2975 38.6035 41.9441 38.4855 41.4728C38.7216 41.9441 38.7216 42.4153 38.6035 42.8866C38.6035 42.8866 38.6035 43.0044 38.6035 43.1223Z",
    fill: "url(#paint12_radial_704_7329)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4862 41.7084C39.1945 43.3579 37.6598 45.4787 35.1806 46.539C32.7015 47.4816 30.1043 47.0103 29.3959 45.243C28.6876 43.5935 30.2223 41.4728 32.7015 40.4124C35.2987 39.4698 37.8959 39.9411 38.4862 41.7084Z",
    fill: "#FCCE3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4854 41.355C39.1938 43.1223 37.6591 45.3609 35.0618 46.4213C32.4646 47.4817 29.7493 46.7747 29.1591 45.0074C28.4507 43.2401 29.9854 41.0015 32.5827 39.9412C35.0618 38.9986 37.7771 39.5877 38.4854 41.355Z",
    fill: "url(#paint13_radial_704_7329)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8752 45.95C31.7572 46.0678 31.6391 46.0678 31.5211 45.95C31.403 45.95 31.2849 45.8321 31.2849 45.7143C30.8127 45.4787 30.3405 45.243 30.1044 44.7718C29.3961 43.4757 30.4586 41.7084 32.4655 40.7659C33.528 40.2946 34.7086 40.0589 35.653 40.2946C35.7711 40.1768 35.8891 40.1768 36.0072 40.1768C36.1252 40.1768 36.2433 40.2946 36.2433 40.4124C36.4794 40.5302 36.5974 40.5302 36.7155 40.648C36.8336 40.648 36.9516 40.648 36.9516 40.7659C36.9516 40.7659 37.0697 40.8837 36.9516 41.0015C37.0697 41.1193 37.1877 41.2371 37.1877 41.355C37.8961 42.651 36.8336 44.4183 34.8266 45.3609C33.8822 45.95 32.7016 46.0678 31.8752 45.95Z",
    fill: "#FFFCE4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4232 41.7085C37.8954 43.0045 36.7148 44.7718 34.7079 45.5966C32.701 46.4213 30.576 45.95 30.1037 44.654C29.6315 43.358 30.8121 41.5907 32.819 40.7659C34.826 39.9412 36.8329 40.2947 37.4232 41.7085Z",
    fill: "url(#paint14_radial_704_7329)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9371 41.5906C34.826 40.8837 36.8329 41.2372 37.3051 42.5332C37.4232 42.7688 37.4232 42.8867 37.4232 43.1223C37.6593 42.651 37.6593 42.1797 37.4232 41.7085C36.951 40.4124 34.826 39.9411 32.819 40.7659C30.8121 41.5906 29.6315 43.2401 30.1037 44.654C30.1037 44.7718 30.2218 44.8896 30.2218 44.8896C30.1037 43.7114 31.1662 42.2976 32.9371 41.5906Z",
    fill: "url(#paint15_radial_704_7329)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9362 41.1194C34.8251 40.4125 36.714 40.6481 37.4223 41.7085C37.4223 41.7085 37.4223 41.8263 37.5404 41.8263V41.7085V41.5907C37.0681 40.2946 34.9431 39.8234 32.9362 40.6481C30.9293 41.4728 29.7487 43.1223 30.2209 44.5362V44.654C29.9848 43.358 31.1654 41.8263 32.9362 41.1194Z",
    fill: "url(#paint16_linear_704_7329)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.714 41.2372C36.9501 41.355 37.1862 41.5906 37.4223 41.8263C37.4223 41.8263 37.4223 41.9441 37.5404 41.9441V41.8263V41.7085C37.0681 40.4124 34.9431 39.9411 32.9362 40.7659C30.9293 41.5906 29.7487 43.2401 30.2209 44.654V44.7718C30.2209 44.5361 30.2209 44.4183 30.2209 44.1827C29.9848 43.0045 31.1654 41.5906 32.8181 40.8837C34.3529 40.059 36.0056 40.2946 36.714 41.2372Z",
    fill: "url(#paint17_radial_704_7329)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7068 38.763C52.7693 40.059 52.2971 42.5333 50.6443 44.4184C48.9915 46.3035 46.5124 46.8926 45.0957 45.9501C44.7415 45.7144 44.3874 45.4788 44.0332 45.1253L47.4568 41.4729L50.7624 37.7026C51.1165 38.0561 51.4707 38.4096 51.7068 38.763Z",
    fill: "url(#paint18_linear_704_7329)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4703 39.2343C52.1786 40.1768 52.0605 41.9441 50.998 43.358C49.9355 44.7718 48.4008 45.3609 47.4564 44.7718C47.2203 44.654 46.9842 44.4184 46.748 44.1827L48.755 41.355L50.7619 38.5273C51.1161 38.763 51.3522 38.9986 51.4703 39.2343Z",
    fill: "url(#paint19_radial_704_7329)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7077 39.2343C52.6521 40.4125 52.298 42.5332 50.7632 44.1827C49.3466 45.7144 47.5757 46.4213 46.2771 45.8322C45.3327 45.95 44.5063 45.7144 43.916 45.2431C44.2702 45.5966 44.6243 45.8322 44.9785 46.0678C46.3952 47.0104 48.8743 46.4213 50.5271 44.5362C52.1799 42.651 52.7702 40.1768 51.5896 38.8808C51.3535 38.5273 50.9994 38.1739 50.6452 37.9382C50.9994 38.2917 51.2355 38.763 51.3535 39.2343C51.5896 39.1164 51.5896 39.1164 51.7077 39.2343Z",
    fill: "url(#paint20_radial_704_7329)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9989 37.9382C52.2975 39.1164 51.9434 41.7085 50.0545 43.7114C48.1656 45.7144 45.6864 46.3035 44.3878 45.1253C43.0892 43.9471 43.4434 41.355 45.3322 39.3521C47.1031 37.3491 49.7003 36.76 50.9989 37.9382Z",
    fill: "#FCCE3A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7627 37.7026C52.1794 38.9986 51.7072 41.7085 49.8183 43.7114C47.9294 45.7144 45.2141 46.3035 43.9155 45.1253C42.4988 43.8292 42.9711 41.1194 44.86 39.1164C46.7488 37.1135 49.3461 36.4066 50.7627 37.7026Z",
    fill: "url(#paint21_radial_704_7329)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8664 44.7718C46.8664 44.8897 46.7483 44.8897 46.5122 45.0075C46.3942 45.0075 46.2761 45.0075 46.2761 44.8897C45.6858 44.8897 45.2136 44.7718 44.8595 44.5362C43.6789 43.7115 43.915 41.5907 45.2136 39.8234C45.922 38.8808 46.8664 38.2917 47.8108 38.0561C47.8108 37.9383 47.9289 37.8204 48.165 37.8204C48.2831 37.8204 48.4011 37.8204 48.5192 37.9383C48.7553 37.9383 48.8733 37.9383 49.1095 37.9383C49.2275 37.8204 49.2275 37.8204 49.3456 37.9383C49.4636 37.9383 49.4636 38.0561 49.4636 38.0561C49.5817 38.1739 49.8178 38.1739 49.9358 38.2917C51.1164 39.1165 50.8803 41.2372 49.5817 43.0045C48.6372 43.8293 47.6928 44.5362 46.8664 44.7718Z",
    fill: "#FFFCE4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9358 38.5273C50.9983 39.4698 50.6441 41.5906 49.1094 43.1223C47.5747 44.6539 45.5678 45.243 44.5053 44.3005C43.4428 43.3579 43.7969 41.2371 45.3317 39.7055C46.8664 38.1738 48.8733 37.4669 49.9358 38.5273Z",
    fill: "url(#paint22_radial_704_7329)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9224 40.4124C47.3391 38.8807 49.2279 38.4094 50.2904 39.352C50.4085 39.4698 50.5266 39.5877 50.6446 39.8233C50.6446 39.352 50.4085 38.8807 50.0543 38.5273C48.9918 37.5847 46.9849 38.056 45.4502 39.7055C43.9154 41.355 43.6793 43.3579 44.6238 44.3005C44.7418 44.4183 44.7418 44.4183 44.8599 44.5361C44.2696 43.4757 44.6238 41.7084 45.9224 40.4124Z",
    fill: "url(#paint23_radial_704_7329)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6861 39.9411C46.9847 38.5273 48.8736 37.9382 49.9361 38.6451C49.9361 38.6451 50.0541 38.6451 50.0541 38.7629C50.0541 38.7629 50.0541 38.6451 49.9361 38.6451C49.9361 38.6451 49.9361 38.6451 49.818 38.5273C48.7555 37.5847 46.7486 38.056 45.2138 39.7055C43.6791 41.355 43.443 43.3579 44.3875 44.3005C44.3875 44.3005 44.3875 44.3005 44.5055 44.4183C44.5055 44.4183 44.6236 44.4183 44.6236 44.5361C44.6236 44.5361 44.6236 44.4183 44.5055 44.4183C44.0333 43.2401 44.3875 41.355 45.6861 39.9411Z",
    fill: "url(#paint24_linear_704_7329)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1097 38.2917C49.4638 38.2917 49.7 38.4095 49.9361 38.5273C49.9361 38.5273 50.0541 38.5273 50.0541 38.6451C50.0541 38.6451 50.0541 38.5273 49.9361 38.5273C49.9361 38.5273 49.9361 38.5273 49.818 38.4095C48.7555 37.4669 46.7486 37.9382 45.2138 39.5877C43.6791 41.2372 43.443 43.2401 44.3875 44.1827C44.3875 44.1827 44.3875 44.1827 44.5055 44.3005C44.5055 44.3005 44.6236 44.3005 44.6236 44.4183C44.6236 44.4183 44.6236 44.3005 44.5055 44.3005C44.3875 44.1827 44.2694 43.947 44.2694 43.7114C43.5611 42.7688 43.9152 41.0015 45.2138 39.5877C46.5125 38.4095 48.1652 37.8204 49.1097 38.2917Z",
    fill: "url(#paint25_radial_704_7329)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3186 43.7114C41.3186 45.1253 39.4297 46.1856 37.1866 46.1856C34.9436 46.1856 33.0547 45.0074 33.0547 43.7114C33.0547 42.2976 34.9436 41.2372 37.1866 41.2372C39.4297 41.2372 41.3186 42.2976 41.3186 43.7114Z",
    fill: "url(#paint26_linear_704_7329)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5068 47.8352C43.2082 49.0134 40.729 48.6599 38.722 47.0104C36.7151 45.3609 35.8887 43.0045 36.8332 41.4729C37.0693 41.1194 37.3054 40.7659 37.6595 40.4125L41.5554 43.5936L45.4512 46.7748C45.097 47.2461 44.8609 47.5995 44.5068 47.8352Z",
    fill: "url(#paint27_linear_704_7329)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9162 47.7174C42.9717 48.5421 41.2009 48.4243 39.6662 47.4817C38.1314 46.5392 37.5412 45.0075 38.1314 44.065C38.2495 43.8293 38.4856 43.5937 38.7217 43.358L41.6731 45.2432L44.6245 47.1283C44.3884 47.2461 44.1523 47.4817 43.9162 47.7174Z",
    fill: "url(#paint28_radial_704_7329)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0345 47.8352C42.972 48.7777 40.729 48.5421 39.0762 47.2461C37.4234 45.95 36.7151 44.1827 37.1873 42.8867C36.9512 41.9441 37.1873 41.1194 37.6595 40.4125C37.3054 40.7659 37.0693 41.1194 36.8332 41.4729C35.8887 43.0045 36.7151 45.3609 38.722 47.0104C40.729 48.6599 43.2082 48.8955 44.5068 47.8352C44.8609 47.4817 45.097 47.2461 45.4512 46.8926C45.097 47.2461 44.7429 47.5995 44.2707 47.7173C44.1526 47.7173 44.0345 47.8352 44.0345 47.8352Z",
    fill: "url(#paint29_radial_704_7329)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2152 47.1282C44.0346 48.542 41.4374 48.3064 39.4305 46.5391C37.3055 44.8896 36.5971 42.2976 37.7777 40.8837C38.9583 39.4699 41.5555 39.7055 43.5624 41.4728C45.5694 43.2401 46.3958 45.7144 45.2152 47.1282Z",
    fill: "#FCCE3A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4521 46.8926C44.2715 48.3064 41.5563 48.0708 39.3132 46.4213C37.1882 44.654 36.3618 42.062 37.5424 40.5303C38.7229 39.1164 41.4382 39.3521 43.6813 41.0016C45.8063 42.7689 46.6327 45.4787 45.4521 46.8926Z",
    fill: "url(#paint30_radial_704_7329)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1326 43.358C38.0145 43.358 37.8965 43.2402 37.8965 43.1224C37.8965 43.0045 37.8965 42.8867 38.0145 42.8867C37.8965 42.2976 38.0145 41.8263 38.2507 41.355C39.077 40.1768 41.202 40.1768 42.9729 41.4729C43.9173 42.1798 44.6257 43.1224 44.9798 43.9471C45.0979 43.9471 45.2159 44.0649 45.2159 44.3006C45.2159 44.4184 45.2159 44.5362 45.0979 44.654C45.0979 44.8897 45.0979 45.0075 45.0979 45.2431C45.2159 45.2431 45.2159 45.3609 45.2159 45.4788C45.2159 45.5966 45.0979 45.5966 45.0979 45.5966C45.0979 45.7144 44.9798 45.95 44.8618 46.0679C44.0354 47.2461 41.9104 47.2461 40.1395 45.95C39.1951 45.1253 38.4868 44.1827 38.1326 43.358Z",
    fill: "#FFFCE4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6244 46.0678C43.68 47.1282 41.673 46.8925 39.9022 45.5965C38.2494 44.1827 37.5411 42.1797 38.4855 41.1193C39.43 40.059 41.4369 40.2946 43.2077 41.5906C44.8605 43.0045 45.5689 45.0074 44.6244 46.0678Z",
    fill: "url(#paint31_radial_704_7329)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4991 42.1797C44.0339 43.4758 44.7422 45.3609 43.7977 46.4213C43.6797 46.5391 43.5616 46.6569 43.3255 46.7747C43.7977 46.6569 44.27 46.4213 44.6241 46.0678C45.5686 45.0074 44.8602 43.0045 43.2075 41.5906C41.5547 40.1768 39.4297 39.9412 38.4852 41.1194C38.3672 41.2372 38.3672 41.2372 38.3672 41.355C39.3116 40.7659 41.0825 41.0015 42.4991 42.1797Z",
    fill: "url(#paint32_radial_704_7329)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9714 41.9441C44.5061 43.2401 45.2144 45.0074 44.6241 46.1856C44.6241 46.1856 44.6241 46.3035 44.5061 46.3035C44.5061 46.3035 44.5061 46.3035 44.6241 46.1856C44.6241 46.1856 44.6241 46.1856 44.7422 46.0678C45.6866 45.0074 44.9783 43.0045 43.3255 41.5906C41.6727 40.1768 39.5477 39.9412 38.6033 41.1194C38.6033 41.1194 38.6033 41.2372 38.4852 41.2372C38.4852 41.2372 38.4852 41.355 38.3672 41.355C38.3672 41.355 38.4852 41.355 38.4852 41.2372C39.5477 40.4124 41.4366 40.7659 42.9714 41.9441Z",
    fill: "url(#paint33_linear_704_7329)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7431 45.3609C44.7431 45.7144 44.625 45.95 44.5069 46.1856C44.5069 46.1856 44.5069 46.3035 44.3889 46.3035C44.3889 46.3035 44.3889 46.3035 44.5069 46.1856C44.5069 46.1856 44.5069 46.1856 44.625 46.0678C45.5694 45.0074 44.8611 43.0045 43.2083 41.5906C41.5556 40.1768 39.4306 39.9412 38.4861 41.1194C38.4861 41.1194 38.4861 41.2372 38.3681 41.2372C38.3681 41.2372 38.3681 41.355 38.25 41.355C38.25 41.355 38.3681 41.355 38.3681 41.2372C38.4861 41.1194 38.7222 41.0015 38.8403 41.0015C39.7847 40.2946 41.5556 40.5303 42.9722 41.7085C44.5069 42.651 45.2153 44.3005 44.7431 45.3609Z",
    fill: "url(#paint34_radial_704_7329)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.644 43.7114C50.8801 45.1252 48.7551 46.539 45.8037 47.0103C42.8523 47.4816 40.3732 46.7747 40.137 45.3608C39.9009 43.947 42.0259 42.5332 44.9773 42.0619C47.9287 41.7084 50.5259 42.4153 50.644 43.7114Z",
    fill: "url(#paint35_linear_704_7329)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.533 42.7689C53.5955 44.0649 53.1233 46.5391 51.4705 48.4242C49.6997 50.3094 47.3385 51.0163 45.9219 49.9559C45.5677 49.7203 45.2135 49.4846 44.8594 49.1312L48.283 45.4787L51.7066 41.8263C51.9427 42.1798 52.1788 42.4154 52.533 42.7689Z",
    fill: "url(#paint36_linear_704_7329)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2964 43.3579C53.0048 44.3005 52.8867 46.0678 51.8242 47.4816C50.7617 48.8955 49.227 49.4846 48.2826 48.8955C48.0464 48.7777 47.8103 48.542 47.5742 48.3064L49.5812 45.4787L51.5881 42.651C51.9423 42.8866 52.0603 43.1223 52.2964 43.3579Z",
    fill: "url(#paint37_radial_704_7329)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4147 43.2401C53.3592 44.4183 53.005 46.5391 51.4703 48.1886C50.1717 49.7202 48.2828 50.4272 46.9842 49.8381C46.0397 49.9559 45.2133 49.7202 44.623 49.249C44.9772 49.6024 45.3314 49.8381 45.6855 50.0737C47.1022 51.0163 49.5814 50.4272 51.2342 48.542C53.005 46.6569 53.4772 44.1827 52.2967 42.8867C52.0605 42.5332 51.7064 42.1797 51.3522 41.9441C51.7064 42.2976 51.9425 42.7688 52.0605 43.2401C52.4147 43.1223 52.4147 43.2401 52.4147 43.2401Z",
    fill: "url(#paint38_radial_704_7329)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8251 42.062C53.1237 43.2402 52.7695 45.8322 50.8806 47.8351C48.9917 49.8381 46.5126 50.4272 45.214 49.249C43.9154 48.0708 44.2695 45.4787 46.1584 43.4758C47.9292 41.4729 50.4084 40.7659 51.8251 42.062Z",
    fill: "#FCCE3A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5891 41.8263C53.0057 43.1223 52.6516 45.8322 50.7627 47.8351C48.8738 49.8381 46.1585 50.545 44.8599 49.249C43.4432 47.953 43.7974 45.2431 45.6863 43.2402C47.4571 41.1194 50.1724 40.5303 51.5891 41.8263Z",
    fill: "url(#paint39_radial_704_7329)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5754 48.7777C47.5754 48.8955 47.4573 48.8955 47.2212 49.0133C47.1032 49.0133 46.9851 49.0133 46.9851 48.8955C46.3948 48.8955 45.9226 48.8955 45.5684 48.5421C44.3879 47.7173 44.624 45.5965 45.9226 43.8292C46.6309 42.8867 47.5754 42.2976 48.5198 42.0619C48.5198 41.9441 48.6379 41.8263 48.874 41.8263C48.9921 41.8263 49.1101 41.8263 49.2282 41.9441C49.4643 41.9441 49.5823 41.9441 49.8184 41.9441C49.9365 41.8263 49.9365 41.8263 50.0546 41.9441C50.1726 41.9441 50.1726 42.0619 50.1726 42.0619C50.2907 42.0619 50.5268 42.1798 50.6448 42.2976C51.8254 43.1223 51.5893 45.2431 50.2907 47.0104C49.4643 47.953 48.5198 48.5421 47.5754 48.7777Z",
    fill: "#FFFCE4"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.762 42.5333C51.8245 43.4758 51.4703 45.5966 49.9356 47.1282C48.5189 48.7777 46.3939 49.249 45.3314 48.3064C44.2689 47.3639 44.6231 45.2431 46.1578 43.7115C47.6925 42.062 49.6995 41.5907 50.762 42.5333Z",
    fill: "url(#paint40_radial_704_7329)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6304 44.5362C48.0471 43.0045 49.936 42.5332 50.9985 43.4758C51.1165 43.5936 51.2346 43.7114 51.3526 43.9471C51.3526 43.4758 51.1165 43.0045 50.7624 42.651C49.6999 41.7085 47.6929 42.1798 46.1582 43.8293C44.7415 45.4787 44.3874 47.4817 45.3318 48.4242C45.4499 48.5421 45.4498 48.5421 45.5679 48.6599C45.0957 47.4817 45.4499 45.8322 46.6304 44.5362Z",
    fill: "url(#paint41_radial_704_7329)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5132 44.0649C47.8118 42.6511 49.7007 42.062 50.7632 42.6511C50.7632 42.6511 50.8813 42.6511 50.8813 42.7689C50.8813 42.7689 50.8813 42.6511 50.7632 42.6511C50.7632 42.6511 50.7632 42.6511 50.6452 42.5333C49.5827 41.5907 47.5757 42.062 46.041 43.7115C44.6243 45.3609 44.2702 47.3639 45.2146 48.3064C45.2146 48.3064 45.2146 48.3064 45.3327 48.4243C45.3327 48.4243 45.4507 48.4243 45.4507 48.5421C45.4507 48.5421 45.4507 48.4243 45.3327 48.4243C44.7424 47.3639 45.2146 45.4788 46.5132 44.0649Z",
    fill: "url(#paint42_linear_704_7329)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9368 42.4154C50.291 42.4154 50.5271 42.5333 50.7632 42.6511C50.7632 42.6511 50.8813 42.6511 50.8813 42.7689C50.8813 42.7689 50.8813 42.6511 50.7632 42.6511C50.7632 42.6511 50.7632 42.6511 50.6452 42.5333C49.5827 41.5907 47.5757 42.062 46.041 43.7115C44.6243 45.3609 44.2702 47.3639 45.2146 48.3064C45.2146 48.3064 45.2146 48.3064 45.3327 48.4243C45.3327 48.4243 45.4507 48.4243 45.4507 48.5421C45.4507 48.5421 45.4507 48.4243 45.3327 48.4243C45.2146 48.3064 45.0966 48.0708 45.0966 47.8352C44.3882 46.8926 44.7424 45.1253 46.041 43.7115C47.3396 42.4154 48.8743 41.9442 49.9368 42.4154Z",
    fill: "url(#paint43_radial_704_7329)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3121 46.3035C39.4301 48.0708 37.7773 49.8381 35.2982 50.4272C32.819 51.0163 30.4579 50.3094 29.7496 48.6599C29.6315 48.1886 29.3954 47.8351 29.2773 47.3639L34.1176 46.1856L38.9579 45.0074C39.194 45.4787 39.3121 45.95 39.3121 46.3035Z",
    fill: "url(#paint44_linear_704_7329)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8396 46.6569C38.9577 47.8351 37.7771 49.2489 36.1244 49.838C34.4716 50.4271 32.8188 50.0737 32.4646 49.0133C32.3466 48.7777 32.2285 48.4242 32.2285 48.1886L35.5341 47.0104L38.8396 45.8322C38.7216 46.0678 38.8396 46.4213 38.8396 46.6569Z",
    fill: "url(#paint45_radial_704_7329)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.076 46.7747C39.194 48.1886 37.7773 49.8381 35.5343 50.4272C33.5273 51.0163 31.6385 50.4272 30.9301 49.3668C30.1037 49.0133 29.5135 48.3064 29.2773 47.4817C29.3954 47.9529 29.5135 48.4242 29.7496 48.7777C30.4579 50.4272 32.819 51.1341 35.2982 50.545C37.7773 49.9559 39.5482 48.0708 39.3121 46.4213C39.3121 45.95 39.194 45.5965 39.076 45.1252C39.194 45.5965 39.194 46.0678 38.9579 46.5391C38.9579 46.5391 39.076 46.6569 39.076 46.7747Z",
    fill: "url(#paint46_radial_704_7329)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0754 45.361C39.5477 47.1283 37.7768 49.0134 35.1796 49.7203C32.5824 50.3094 30.1032 49.4847 29.631 47.7174C29.1588 45.9501 30.9296 44.0649 33.5268 43.358C36.2421 42.6511 38.7213 43.5937 39.0754 45.361Z",
    fill: "#FCCE3A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0754 45.0075C39.5476 46.8926 37.6587 48.8955 35.0615 49.6024C32.3462 50.3094 29.749 49.3668 29.3948 47.4817C28.9226 45.5966 30.8115 43.5936 33.4087 42.8867C36.124 42.1798 38.6032 43.1223 39.0754 45.0075Z",
    fill: "url(#paint47_radial_704_7329)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8737 48.6598C31.7557 48.6598 31.6376 48.6598 31.5196 48.6598C31.4015 48.6598 31.4015 48.542 31.4015 48.4242C30.9293 48.1885 30.5751 47.8351 30.339 47.3638C29.8668 45.95 31.1654 44.3005 33.2904 43.7114C34.4709 43.3579 35.5334 43.3579 36.4779 43.5935C36.5959 43.4757 36.714 43.4757 36.8321 43.5935C36.9501 43.7114 37.0682 43.7114 36.9501 43.8292C37.0682 43.947 37.3043 44.0648 37.4223 44.1827C37.5404 44.1827 37.6584 44.1826 37.6584 44.3005C37.6584 44.4183 37.6584 44.4183 37.6584 44.5361C37.7765 44.6539 37.7765 44.7718 37.8946 45.0074C38.3668 46.4212 37.0682 48.0707 34.9432 48.6598C33.8807 49.0133 32.8182 49.0133 31.8737 48.6598Z",
    fill: "#FFFCE4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.013 45.1253C38.3672 46.5391 36.9505 48.0708 34.8255 48.5421C32.7005 49.0134 30.6936 48.4243 30.3394 47.0104C29.9852 45.5966 31.4019 44.0649 33.5269 43.5936C35.6519 43.1224 37.6588 43.8293 38.013 45.1253Z",
    fill: "url(#paint48_radial_704_7329)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5269 44.5362C35.5338 44.0649 37.4227 44.654 37.7769 45.95C37.7769 46.1856 37.7769 46.3035 37.7769 46.5391C38.013 46.0678 38.1311 45.5965 38.013 45.1253C37.6588 43.7114 35.6519 43.0045 33.5269 43.5936C31.4019 44.0649 29.9852 45.7144 30.3394 47.0104C30.3394 47.1282 30.3394 47.246 30.4574 47.246C30.4574 46.1856 31.7561 45.0074 33.5269 44.5362Z",
    fill: "url(#paint49_radial_704_7329)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6449 44.0649C35.5338 43.5936 37.4227 44.1827 38.013 45.2431V45.1253C37.6588 43.7114 35.6519 43.0045 33.5269 43.5936C31.4019 44.0649 29.9852 45.7144 30.3394 47.0104V47.1282C30.3394 45.8322 31.7561 44.5362 33.6449 44.0649Z",
    fill: "url(#paint50_linear_704_7329)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4227 44.654C37.6588 44.8896 37.895 45.1252 38.013 45.3609V45.2431C37.6588 43.8292 35.6519 43.1223 33.5269 43.7114C31.4019 44.1827 29.9852 45.8322 30.3394 47.1282V47.246C30.3394 47.0104 30.3394 46.8925 30.4574 46.6569C30.4574 45.4787 31.638 44.1827 33.4088 43.7114C35.1797 43.2401 36.8325 43.5936 37.4227 44.654Z",
    fill: "url(#paint51_radial_704_7329)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M38.9575 50.7806C41.6307 50.7806 43.7977 49.6729 43.7977 48.3064C43.7977 46.9399 41.6307 45.8322 38.9575 45.8322C36.2843 45.8322 34.1172 46.9399 34.1172 48.3064C34.1172 49.6729 36.2843 50.7806 38.9575 50.7806Z",
    fill: "url(#paint52_linear_704_7329)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2214 46.6569C47.5755 48.3064 46.0408 50.3093 43.5616 51.2519C41.2005 52.0766 38.7214 51.6053 37.895 50.0737C37.6589 49.7202 37.5408 49.2489 37.3047 48.7777L42.0269 47.0103L46.7491 45.243C47.1033 45.8321 47.2214 46.3034 47.2214 46.6569Z",
    fill: "url(#paint53_linear_704_7329)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8681 47.1281C47.1042 48.3063 46.0417 49.8379 44.5069 50.6627C42.8542 51.4874 41.3194 51.2518 40.7292 50.3092C40.6111 50.0736 40.4931 49.8379 40.375 49.4845L43.4444 47.9528L46.5139 46.4211C46.75 46.539 46.75 46.7746 46.8681 47.1281Z",
    fill: "url(#paint54_radial_704_7329)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9852 47.1281C47.2214 48.542 45.9227 50.3093 43.9158 51.134C42.0269 51.8409 40.02 51.6053 39.1936 50.5449C38.3672 50.1915 37.6589 49.6024 37.3047 48.8954C37.4227 49.3667 37.6589 49.7202 37.895 50.1915C38.7214 51.7231 41.2005 52.1944 43.5616 51.3697C45.9227 50.5449 47.5755 48.542 47.2214 46.7747C47.1033 46.3034 46.9852 45.9499 46.8672 45.4786C46.9852 45.9499 47.1033 46.4212 46.9852 46.8925C46.9852 47.0103 46.9852 47.0103 46.9852 47.1281Z",
    fill: "url(#paint55_radial_704_7329)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9861 45.7143C47.5764 47.3637 46.0417 49.4845 43.5625 50.4271C41.0834 51.3696 38.4861 50.6627 37.8959 49.0132C37.3056 47.3637 38.8403 45.243 41.3195 44.3004C43.7986 43.3578 46.3959 43.9469 46.9861 45.7143Z",
    fill: "#FCCE3A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8673 45.3608C47.4576 47.1281 45.9229 49.3667 43.3256 50.3093C40.7284 51.2518 38.0131 50.5449 37.4229 48.7776C36.8326 47.0103 38.3673 44.7717 40.9645 43.8291C43.5617 42.8866 46.277 43.5935 46.8673 45.3608Z",
    fill: "url(#paint56_radial_704_7329)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1383 49.838C40.0203 49.9558 39.9022 49.9558 39.7841 49.838C39.6661 49.838 39.6661 49.7202 39.548 49.6024C39.0758 49.3667 38.6036 49.0133 38.3675 48.6598C37.7772 47.3638 38.8397 45.5965 40.8466 44.6539C41.9091 44.1826 43.0897 44.0648 44.0341 44.1826C44.1522 44.0648 44.2702 44.0648 44.3883 44.0648C44.5064 44.0648 44.6244 44.1826 44.6244 44.3005C44.8605 44.4183 44.9786 44.4183 45.0966 44.5361C45.2147 44.5361 45.3328 44.5361 45.3328 44.6539C45.3328 44.6539 45.4508 44.7717 45.3328 44.8896C45.4508 45.0074 45.5689 45.1252 45.5689 45.243C46.1591 46.539 45.0966 48.3063 43.0897 49.2489C42.1453 49.838 41.0828 49.9558 40.1383 49.838Z",
    fill: "#FFFCE4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8042 45.7143C46.2764 47.0103 44.9778 48.7776 42.9708 49.4845C40.9639 50.1914 38.8389 49.7201 38.3667 48.4241C37.8944 47.1281 39.193 45.3608 41.2 44.6539C43.325 43.8291 45.3319 44.3004 45.8042 45.7143Z",
    fill: "url(#paint57_radial_704_7329)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3191 45.4787C43.208 44.7717 45.215 45.243 45.6872 46.5391C45.8052 46.7747 45.8052 46.8925 45.8052 47.1282C46.0414 46.6569 46.0414 46.1856 45.9233 45.7143C45.4511 44.4183 43.4441 43.947 41.3191 44.6539C39.3122 45.3609 38.0136 47.1282 38.4858 48.4242C38.4858 48.542 38.6039 48.6598 38.6039 48.6598C38.4858 47.4816 39.5483 46.0678 41.3191 45.4787Z",
    fill: "url(#paint58_radial_704_7329)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4372 45.0073C43.3261 44.3004 45.215 44.6538 45.8052 45.7142C45.8052 45.7142 45.8052 45.832 45.9233 45.832V45.7142V45.5964C45.4511 44.3004 43.4441 43.8291 41.3191 44.536C39.3122 45.2429 38.0136 47.0102 38.4858 48.3063V48.4241C38.3677 47.1281 39.5483 45.7142 41.4372 45.0073Z",
    fill: "url(#paint59_linear_704_7329)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.215 45.1251C45.4511 45.2429 45.6872 45.4786 45.8052 45.7142C45.8052 45.7142 45.8052 45.832 45.9233 45.832V45.7142V45.5964C45.4511 44.3004 43.4441 43.8291 41.3191 44.536C39.3122 45.2429 38.0136 47.0102 38.4858 48.3063V48.4241C38.4858 48.1884 38.4858 48.0706 38.4858 47.835C38.3677 46.6568 39.4302 45.2429 41.2011 44.6538C42.8539 44.0647 44.5066 44.3004 45.215 45.1251Z",
    fill: "url(#paint60_radial_704_7329)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4028 44.8895C66.1111 46.4212 65.0486 48.7776 62.9236 50.0736C60.7986 51.4874 58.3194 51.4874 57.1389 50.1914C56.7847 49.838 56.5486 49.4845 56.3125 49.131L60.5625 46.4212L64.8125 43.7113C65.0486 44.0648 65.1667 44.4182 65.4028 44.8895Z",
    fill: "url(#paint61_linear_704_7329)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2847 45.243C65.875 46.539 65.0486 48.5419 63.1597 49.838C61.5069 51.0162 59.5 51.134 58.4375 50.3092C57.4931 50.1914 56.7847 49.838 56.3125 49.131C56.5486 49.6023 56.7847 49.838 57.1389 50.1914C58.3194 51.4874 60.7986 51.4874 62.9236 50.0736C65.0486 48.6598 66.1111 46.4212 65.4028 44.8895C65.1667 44.536 65.0486 44.0648 64.6944 43.7113C64.9306 44.1826 65.0486 44.6539 65.0486 45.1251C65.1667 45.1251 65.1667 45.243 65.2847 45.243Z",
    fill: "url(#paint62_radial_704_7329)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9305 43.947C65.8749 45.4787 64.9305 47.8351 62.5694 49.3667C60.3263 50.7806 57.7291 50.7806 56.6666 49.2489C55.7222 47.7172 56.6666 45.3608 59.0277 43.8292C61.2708 42.4153 63.868 42.4153 64.9305 43.947Z",
    fill: "#FCCE3A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6936 43.5935C65.7561 45.243 64.6936 47.7172 62.3325 49.2489C59.9714 50.7805 57.2561 50.6627 56.1936 49.1311C55.1311 47.4816 56.1936 45.0074 58.5548 43.4757C60.9159 41.944 63.7492 42.0618 64.6936 43.5935Z",
    fill: "url(#paint63_radial_704_7329)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1445 49.4845C59.0265 49.6023 58.9084 49.6023 58.7904 49.6023C58.6723 49.6023 58.5543 49.4845 58.5543 49.4845C57.964 49.3667 57.4918 49.131 57.2556 48.7776C56.3112 47.5994 57.0195 45.7142 58.7904 44.3004C59.7348 43.5935 60.7973 43.24 61.7418 43.24C61.8598 43.1222 61.9779 43.1222 62.0959 43.1222C62.214 43.1222 62.332 43.24 62.332 43.3578C62.5681 43.3578 62.6862 43.4757 62.9223 43.4757C63.0404 43.4757 63.0404 43.4757 63.1584 43.4757C63.2765 43.4757 63.2765 43.5935 63.2765 43.7113C63.3945 43.8291 63.5126 43.9469 63.6306 44.0648C64.5751 45.243 63.8668 47.1281 62.0959 48.5419C61.1515 49.0132 60.089 49.4845 59.1445 49.4845Z",
    fill: "#FFFCE4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7496 44.1826C64.576 45.3608 63.6315 47.2459 61.8607 48.4241C60.0898 49.6023 57.9648 49.6023 57.1385 48.4241C56.3121 47.2459 57.2565 45.3608 59.0273 44.1826C60.9162 43.0044 62.9232 43.0044 63.7496 44.1826Z",
    fill: "url(#paint64_radial_704_7329)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3806 45.0074C61.1515 43.947 63.1584 43.947 63.8668 45.0074C63.9848 45.1252 64.1029 45.3608 64.1029 45.4786C64.2209 45.0074 64.1029 44.4183 63.8668 44.0648C63.0404 42.8866 61.0334 42.8866 59.1445 44.0648C57.3737 45.243 56.4293 47.1281 57.2556 48.3063C57.2556 48.4242 57.3737 48.4242 57.4918 48.542C57.0195 47.5994 57.8459 45.9499 59.3806 45.0074Z",
    fill: "url(#paint65_radial_704_7329)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2626 44.5361C60.9154 43.4757 62.8043 43.3579 63.7487 44.3004C63.7487 44.3004 63.7487 44.3004 63.8668 44.4182V44.3004V44.1826C63.0404 43.0044 61.0334 43.0044 59.1445 44.1826C57.3737 45.3608 56.4293 47.2459 57.2556 48.4241C57.2556 48.4241 57.2556 48.542 57.3737 48.542C57.3737 48.542 57.3737 48.6598 57.4918 48.6598V48.542C56.7834 47.2459 57.6098 45.5964 59.2626 44.5361Z",
    fill: "url(#paint66_linear_704_7329)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0404 43.8291C63.3945 43.947 63.6306 44.0648 63.7487 44.3004C63.7487 44.3004 63.7487 44.3004 63.8668 44.4182V44.3004V44.1826C63.0404 43.0044 61.0334 43.0044 59.1445 44.1826C57.3737 45.3608 56.4293 47.2459 57.2556 48.4241C57.2556 48.4241 57.2556 48.542 57.3737 48.542C57.3737 48.542 57.3737 48.6598 57.4918 48.6598V48.542C57.3737 48.3063 57.3737 48.1885 57.3737 47.9529C56.9015 46.8925 57.7279 45.243 59.2626 44.1826C60.4431 43.24 62.0959 43.1222 63.0404 43.8291Z",
    fill: "url(#paint67_radial_704_7329)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8388 54.6686C38.6027 56.5538 36.2415 57.9676 33.5263 57.9676C30.6929 57.9676 28.4499 56.5538 28.2138 54.6686C28.0957 54.1973 28.0957 53.7261 28.0957 53.137H33.5263H38.9568C38.9568 53.7261 38.9568 54.1973 38.8388 54.6686Z",
    fill: "url(#paint68_linear_704_7329)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.248 54.9042C38.0119 56.2003 36.4772 57.3785 34.5883 57.6141C32.6994 57.8497 31.0467 57.025 30.9286 55.8468C30.9286 55.4933 30.8105 55.2577 30.8105 54.9042L34.5883 54.433L38.3661 53.9617C38.3661 54.1973 38.248 54.5508 38.248 54.9042Z",
    fill: "url(#paint69_radial_704_7329)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4846 54.9043C38.2485 56.4359 36.2415 57.732 33.8804 57.8498C31.6374 57.9676 29.7485 56.9072 29.3943 55.4934C28.5679 54.9043 28.0957 54.0795 28.0957 53.137C28.0957 53.7261 28.0957 54.0795 28.2138 54.6686C28.4499 56.5538 30.811 57.9676 33.5263 57.9676C36.3596 57.9676 38.6027 56.5538 38.8388 54.6686C38.9568 54.1973 38.9568 53.7261 38.9568 53.137C38.9568 53.7261 38.8388 54.1973 38.4846 54.6686C38.4846 54.7865 38.4846 54.9043 38.4846 54.9043Z",
    fill: "url(#paint70_radial_704_7329)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.957 53.4904C38.957 55.4934 36.5959 57.025 33.6445 57.025C30.6931 57.025 28.332 55.4934 28.332 53.4904C28.332 51.4875 30.6931 49.9558 33.6445 49.9558C36.5959 49.9558 38.957 51.4875 38.957 53.4904Z",
    fill: "#FCCE3A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9568 53.1369C38.9568 55.1399 36.4776 56.9072 33.5263 56.9072C30.4568 56.9072 28.0957 55.2577 28.0957 53.1369C28.0957 51.134 30.5749 49.3667 33.5263 49.3667C36.4776 49.4845 38.9568 51.134 38.9568 53.1369Z",
    fill: "url(#paint71_radial_704_7329)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4565 55.1399C30.3385 55.1399 30.2204 55.1399 30.1024 55.0221C29.9843 54.9042 29.9843 54.7864 29.9843 54.7864C29.5121 54.4329 29.276 53.8438 29.1579 53.3726C29.0399 51.8409 30.8107 50.4271 33.1718 50.1914C34.4704 50.0736 35.651 50.4271 36.4774 50.8983C36.5954 50.8983 36.8315 50.8983 36.9496 51.0162C37.0676 51.134 37.0676 51.2518 37.0676 51.3696C37.1857 51.4874 37.3038 51.7231 37.4218 51.8409C37.5399 51.8409 37.6579 51.9587 37.6579 51.9587C37.6579 52.0765 37.6579 52.0765 37.6579 52.1944C37.776 52.3122 37.776 52.5478 37.776 52.6656C37.894 54.1973 36.1232 55.6112 33.7621 55.8468C32.4635 55.9646 31.2829 55.729 30.4565 55.1399Z",
    fill: "#FFFCE4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7754 53.0191C37.7754 54.5508 35.8865 55.8468 33.5254 55.8468C31.1643 55.8468 29.2754 54.5508 29.2754 53.0191C29.2754 51.4874 31.1643 50.1914 33.5254 50.1914C35.8865 50.1914 37.7754 51.4874 37.7754 53.0191Z",
    fill: "url(#paint72_radial_704_7329)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1721 51.2518C35.4151 51.2518 37.186 52.43 37.186 53.8438C37.186 54.0795 37.186 54.1973 37.0679 54.4329C37.4221 53.9617 37.6582 53.4904 37.6582 53.0191C37.6582 51.4874 35.7693 50.1914 33.4082 50.1914C31.0471 50.1914 29.1582 51.4874 29.1582 53.0191C29.1582 53.1369 29.1582 53.2547 29.1582 53.3726C29.6304 52.1944 31.2832 51.2518 33.1721 51.2518Z",
    fill: "url(#paint73_radial_704_7329)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5254 50.7805C35.6504 50.7805 37.4212 51.8409 37.7754 53.1369V53.0191C37.7754 51.4874 35.8865 50.1914 33.5254 50.1914C31.1643 50.1914 29.2754 51.4874 29.2754 53.0191V53.1369C29.5115 51.8409 31.2823 50.7805 33.5254 50.7805Z",
    fill: "url(#paint74_linear_704_7329)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3032 52.3122C37.5393 52.5478 37.6573 52.9013 37.7754 53.1369V53.0191C37.7754 51.4874 35.8865 50.1914 33.5254 50.1914C31.1643 50.1914 29.2754 51.4874 29.2754 53.0191V53.1369C29.2754 52.9013 29.3934 52.7835 29.5115 52.5478C29.7476 51.2518 31.4004 50.3092 33.4073 50.3092C35.2962 50.3092 36.949 51.134 37.3032 52.3122Z",
    fill: "url(#paint75_radial_704_7329)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1853 53.6082C36.8312 51.0162 32.4631 50.6627 30.5742 51.9587C31.7548 52.9013 34.2339 54.1973 37.1853 53.6082Z",
    fill: "url(#paint76_radial_704_7329)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9781 52.0766C44.742 53.8439 42.617 55.1399 40.0197 55.1399C37.4225 55.1399 35.2975 53.8439 35.0614 52.0766C34.9434 51.6053 34.9434 51.2518 34.9434 50.6627H40.0197H45.0961C45.0961 51.2518 45.0961 51.7231 44.9781 52.0766Z",
    fill: "url(#paint77_linear_704_7329)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6239 52.43C44.3878 53.8438 42.617 55.022 40.3739 55.1399C38.367 55.1399 36.5961 54.3151 36.1239 53.0191C35.4156 52.43 34.9434 51.6053 34.9434 50.7805C34.9434 51.2518 34.9434 51.7231 35.0614 52.1944C35.2975 53.9617 37.4225 55.2577 40.0197 55.2577C42.617 55.2577 44.742 53.9617 44.9781 52.1944C45.0961 51.7231 45.0961 51.3696 45.0961 50.7805C45.0961 51.2518 44.9781 51.7231 44.6239 52.1944C44.6239 52.1944 44.6239 52.3122 44.6239 52.43Z",
    fill: "url(#paint78_radial_704_7329)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0966 51.0163C45.0966 52.7836 42.9716 54.3152 40.2563 54.3152C37.541 54.3152 35.416 52.9014 35.416 51.0163C35.416 49.2489 37.541 47.7173 40.2563 47.7173C42.8535 47.8351 45.0966 49.2489 45.0966 51.0163Z",
    fill: "#FCCE3A"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0961 50.7806C45.0961 52.6657 42.8531 54.1973 40.0197 54.1973C37.1864 54.1973 34.9434 52.6657 34.9434 50.7806C34.9434 48.8954 37.1864 47.3638 40.0197 47.3638C42.8531 47.3638 45.0961 48.8954 45.0961 50.7806Z",
    fill: "url(#paint79_radial_704_7329)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3037 52.6657C37.1856 52.6657 37.0676 52.6657 36.9495 52.5479C36.8315 52.43 36.8315 52.43 36.8315 52.3122C36.4773 51.9588 36.1231 51.4875 36.1231 51.0162C36.0051 49.6024 37.6579 48.3063 39.7829 48.0707C40.9634 47.9529 42.144 48.3063 42.8523 48.7776C42.9704 48.7776 43.0884 48.7776 43.2065 48.8954C43.3245 49.0133 43.3245 49.1311 43.3245 49.2489C43.4426 49.3667 43.5606 49.4845 43.6787 49.7202C43.7968 49.7202 43.7968 49.838 43.9148 49.838C43.9148 49.9558 43.9148 49.9558 43.9148 50.0736C44.0329 50.1915 44.0329 50.4271 44.0329 50.5449C44.1509 51.9588 42.4981 53.2548 40.3731 53.4904C39.1926 53.3726 38.012 53.137 37.3037 52.6657Z",
    fill: "#FFFCE4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0339 50.6627C44.0339 52.0766 42.263 53.2548 40.138 53.2548C38.013 53.2548 36.2422 52.0766 36.2422 50.6627C36.2422 49.2489 38.013 48.0707 40.138 48.0707C42.263 48.0707 44.0339 49.2489 44.0339 50.6627Z",
    fill: "url(#paint80_radial_704_7329)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7839 49.0132C41.7908 49.0132 43.5616 50.0736 43.5616 51.4874C43.5616 51.7231 43.5616 51.8409 43.4436 52.0765C43.7977 51.7231 44.0339 51.2518 44.0339 50.7805C44.0339 49.3667 42.263 48.1885 40.138 48.1885C38.013 48.1885 36.2422 49.3667 36.2422 50.7805C36.2422 50.8983 36.2422 51.0162 36.2422 51.134C36.4783 49.838 38.013 49.0132 39.7839 49.0132Z",
    fill: "url(#paint81_radial_704_7329)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0189 48.542C42.0258 48.542 43.6786 49.4845 43.9147 50.7805V50.6627C43.9147 49.2489 42.1439 48.0707 40.0189 48.0707C37.8939 48.0707 36.123 49.2489 36.123 50.6627V50.7805C36.4772 49.4845 38.13 48.542 40.0189 48.542Z",
    fill: "url(#paint82_linear_704_7329)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5605 49.9558C43.7967 50.1914 43.9147 50.4271 43.9147 50.7805V50.6627C43.9147 49.2489 42.1439 48.0707 40.0189 48.0707C37.8939 48.0707 36.123 49.2489 36.123 50.6627V50.7805C36.123 50.5449 36.2411 50.4271 36.3592 50.1914C36.5953 49.0132 38.13 48.0707 40.0189 48.0707C41.7897 48.0707 43.2064 48.8954 43.5605 49.9558Z",
    fill: "url(#paint83_radial_704_7329)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4214 50.5449C37.5395 52.3122 35.7687 54.0795 33.2895 54.5508C30.8103 55.1399 28.4492 54.3152 27.7409 52.6657C27.6228 52.1944 27.5048 51.8409 27.3867 51.3697L32.3451 50.3093L37.3034 49.2489C37.3034 49.7202 37.3034 50.1915 37.4214 50.5449Z",
    fill: "url(#paint84_linear_704_7329)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0681 50.8984C37.1862 52.3122 35.6515 53.9617 33.5265 54.433C31.5195 54.9043 29.6306 54.433 28.9223 53.2548C28.0959 52.7835 27.5056 52.1944 27.2695 51.3697C27.3876 51.8409 27.5056 52.3122 27.6237 52.6657C28.214 54.3152 30.5751 55.1399 33.1723 54.5508C35.6515 53.9617 37.4223 52.1944 37.3043 50.5449C37.3043 50.0736 37.1862 49.7202 37.0681 49.2489C37.1862 49.7202 37.0681 50.1915 36.9501 50.6627C37.0681 50.7806 37.0681 50.8984 37.0681 50.8984Z",
    fill: "url(#paint85_radial_704_7329)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1868 49.4846C37.5409 51.2519 35.7701 53.137 33.1729 53.7261C30.5757 54.3152 28.0965 53.3726 27.7423 51.6053C27.3882 49.838 29.159 47.9529 31.7562 47.3638C34.3534 46.7747 36.8326 47.7173 37.1868 49.4846Z",
    fill: "#FCCE3A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1855 49.2489C37.6577 51.134 35.7688 53.137 33.0536 53.7261C30.3383 54.3152 27.7411 53.3726 27.3869 51.4875C26.9147 49.6024 28.8036 47.5994 31.5188 47.0103C34.2341 46.4212 36.7133 47.3638 37.1855 49.2489Z",
    fill: "url(#paint86_radial_704_7329)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.867 52.7835C29.7489 52.7835 29.6309 52.7835 29.5128 52.7835C29.3948 52.7835 29.3948 52.6657 29.3948 52.5479C28.9225 52.3122 28.5684 51.841 28.4503 51.3697C27.9781 49.9558 29.2767 48.4242 31.4017 47.7172C32.5823 47.3638 33.6448 47.3638 34.5892 47.7172C34.7073 47.5994 34.8253 47.5994 34.9434 47.7172C35.0614 47.8351 35.1795 47.8351 35.0614 47.9529C35.1795 48.0707 35.4156 48.1885 35.5337 48.3063C35.6517 48.3063 35.7698 48.3063 35.7698 48.4242C35.7698 48.542 35.7698 48.542 35.7698 48.6598C35.8878 48.7776 35.8878 48.8954 36.0059 49.1311C36.4781 50.5449 35.1795 52.0766 33.0545 52.7835C31.8739 53.0192 30.8114 53.0192 29.867 52.7835Z",
    fill: "#FFFCE4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0058 49.3667C36.36 50.7805 34.8252 52.3122 32.7002 52.7835C30.5752 53.2547 28.5683 52.5478 28.3322 51.134C27.978 49.7201 29.5127 48.1885 31.6377 47.7172C33.7627 47.2459 35.7697 47.9528 36.0058 49.3667Z",
    fill: "url(#paint87_radial_704_7329)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6378 48.6597C33.6448 48.1885 35.5337 48.8954 35.7698 50.1914C35.7698 50.427 35.7698 50.5449 35.7698 50.7805C36.0059 50.3092 36.124 49.8379 36.0059 49.3667C35.6517 47.9528 33.7628 47.2459 31.6378 47.7172C29.5128 48.1885 28.0962 49.7201 28.3323 51.134C28.3323 51.2518 28.3323 51.3696 28.4503 51.3696C28.5684 50.1914 29.867 49.0132 31.6378 48.6597Z",
    fill: "url(#paint88_radial_704_7329)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7559 48.1885C33.6448 47.7172 35.5337 48.3063 36.0059 49.4845V49.3667C35.6517 47.9528 33.7628 47.2459 31.6378 47.7172C29.5128 48.1885 28.0962 49.7201 28.3323 51.134V51.2518C28.4503 49.9558 29.867 48.6597 31.7559 48.1885Z",
    fill: "url(#paint89_linear_704_7329)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5328 48.7776C35.7689 49.0132 36.005 49.2488 36.1231 49.4845V49.3667C35.7689 47.9528 33.88 47.2459 31.755 47.7172C29.63 48.1885 28.2134 49.7201 28.4495 51.134V51.2518C28.4495 51.0161 28.4495 50.8983 28.5675 50.6627C28.5675 49.4845 29.8661 48.1885 31.637 47.835C33.2898 47.3637 34.9425 47.835 35.5328 48.7776Z",
    fill: "url(#paint90_radial_704_7329)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7079 50.8984C51.7079 52.3123 49.5829 53.3726 46.8676 53.3726C44.1523 53.3726 42.0273 52.1944 42.0273 50.8984C42.0273 49.6024 44.1523 48.4242 46.8676 48.4242C49.5829 48.4242 51.7079 49.4846 51.7079 50.8984Z",
    fill: "url(#paint91_linear_704_7329)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4783 50.545C53.0061 52.1944 50.763 53.2548 48.1658 52.9014C45.5686 52.5479 43.6797 51.0162 43.6797 49.2489C43.6797 48.7776 43.6797 48.4242 43.7977 47.8351L48.7561 48.4242L53.7144 49.0133C53.5964 49.7202 53.5964 50.0737 53.4783 50.545Z",
    fill: "url(#paint92_linear_704_7329)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0069 50.7806C52.6528 52.1944 50.6458 53.137 48.4028 52.9014C46.3958 52.6657 44.7431 51.6053 44.5069 50.1915C43.9167 49.4846 43.5625 48.6598 43.6806 47.8351C43.5625 48.3064 43.5625 48.7776 43.5625 49.2489C43.5625 51.0162 45.5694 52.5479 48.0486 52.9014C50.6458 53.2548 52.8889 52.1944 53.3611 50.545C53.4792 50.0737 53.5972 49.7202 53.5972 49.2489C53.4792 49.7202 53.3611 50.1915 53.0069 50.545C53.125 50.545 53.0069 50.6628 53.0069 50.7806Z",
    fill: "url(#paint93_radial_704_7329)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5979 49.4846C53.3618 51.2519 51.0007 52.4301 48.4035 52.0766C45.6882 51.7232 43.7993 50.0737 43.9173 48.1886C44.1535 46.4213 46.5146 45.2431 49.1118 45.5965C51.8271 45.95 53.834 47.7173 53.5979 49.4846Z",
    fill: "#FCCE3A"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7148 49.1311C53.4787 51.0162 50.9995 52.3122 48.2842 51.9588C45.5689 51.6053 43.4439 49.838 43.68 47.9529C43.9162 46.0678 46.3953 44.7717 49.1106 45.1252C51.9439 45.4787 53.9509 47.246 53.7148 49.1311Z",
    fill: "url(#paint94_radial_704_7329)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6875 50.0737C45.5694 50.0737 45.4514 50.0737 45.3333 49.9559C45.2153 49.8381 45.2153 49.7202 45.2153 49.7202C44.8611 49.249 44.625 48.7777 44.625 48.3064C44.625 46.8925 46.5139 45.8322 48.6389 45.95C49.8194 46.0678 50.8819 46.4213 51.5903 47.0104C51.7083 47.0104 51.8264 47.0104 51.9444 47.1282C52.0625 47.246 52.0625 47.3638 52.0625 47.4816C52.1806 47.5995 52.2986 47.8351 52.4167 47.9529C52.5347 47.9529 52.5347 48.0707 52.6528 48.0707C52.6528 48.1886 52.6528 48.1886 52.6528 48.3064C52.6528 48.4242 52.7708 48.6599 52.6528 48.7777C52.6528 50.1915 50.7639 51.2519 48.6389 51.1341C47.4583 51.0163 46.3958 50.545 45.6875 50.0737Z",
    fill: "#FFFCE4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6521 48.8954C52.534 50.3093 50.5271 51.2518 48.4021 51.0162C46.2771 50.7806 44.6243 49.3667 44.8604 47.9529C44.9784 46.539 46.9854 45.5965 49.1104 45.8321C51.2354 46.0677 52.7701 47.4816 52.6521 48.8954Z",
    fill: "url(#paint95_radial_704_7329)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6391 46.7747C50.6461 47.0103 52.1808 48.3063 52.0627 49.6024C52.0627 49.838 51.9447 49.9558 51.9447 50.1915C52.2988 49.838 52.653 49.4845 52.653 48.8954C52.771 47.4816 51.2363 46.0677 49.1113 45.8321C46.9863 45.5965 45.0974 46.539 44.8613 47.9529C44.8613 48.0707 44.8613 48.1885 44.8613 48.3063C45.2155 47.1281 46.8683 46.539 48.6391 46.7747Z",
    fill: "url(#paint96_radial_704_7329)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9922 46.3034C50.9991 46.539 52.5339 47.7172 52.5339 49.0133V48.8954C52.6519 47.4816 51.1172 46.0677 48.9922 45.8321C46.8672 45.5965 44.9783 46.539 44.7422 47.9529V48.0707C45.2144 46.8925 46.9852 46.0677 48.9922 46.3034Z",
    fill: "url(#paint97_linear_704_7329)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2977 48.1885C52.4158 48.4242 52.5339 48.7776 52.5339 49.0133V48.8954C52.6519 47.4816 51.1172 46.0677 48.9922 45.8321C46.8672 45.5965 44.9783 46.539 44.7422 47.9529V48.0707C44.8602 47.8351 44.8602 47.7172 44.9783 47.5994C45.3325 46.4212 46.9852 45.7143 48.8741 45.9499C50.763 46.0677 52.0616 47.0103 52.2977 48.1885Z",
    fill: "url(#paint98_radial_704_7329)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M58.6723 50.3093C61.3455 50.3093 63.5126 49.2015 63.5126 47.8351C63.5126 46.4686 61.3455 45.3608 58.6723 45.3608C55.9991 45.3608 53.832 46.4686 53.832 47.8351C53.832 49.2015 55.9991 50.3093 58.6723 50.3093Z",
    fill: "url(#paint99_linear_704_7329)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M54.6586 51.6053C57.3318 51.6053 59.4989 50.4976 59.4989 49.1311C59.4989 47.7646 57.3318 46.6569 54.6586 46.6569C51.9854 46.6569 49.8184 47.7646 49.8184 49.1311C49.8184 50.4976 51.9854 51.6053 54.6586 51.6053Z",
    fill: "url(#paint100_linear_704_7329)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9151 50.0737C59.9707 51.4876 57.4915 51.9589 55.1304 50.8985C52.7693 49.8381 51.3526 47.8352 51.8249 46.1857C51.9429 45.7144 52.061 45.3609 52.2971 44.8896L56.9012 46.8926L61.5054 48.8955C61.2693 49.3668 61.1512 49.7203 60.9151 50.0737Z",
    fill: "url(#paint101_linear_704_7329)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4429 50.1916C59.6165 51.4876 57.4915 51.841 55.4846 51.0163C53.5957 50.3094 52.4151 48.6599 52.5332 47.3639C52.061 46.5391 52.061 45.7144 52.2971 44.8896C52.061 45.3609 51.9429 45.7144 51.8249 46.1857C51.3526 47.8352 52.7693 49.9559 55.1304 50.8985C57.4915 51.9589 59.9707 51.4876 60.9151 50.0737C61.1512 49.7203 61.3874 49.3668 61.5054 48.8955C61.2693 49.3668 60.9151 49.7203 60.561 49.9559C60.561 50.0737 60.4429 50.1916 60.4429 50.1916Z",
    fill: "url(#paint102_radial_704_7329)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.387 49.1311C60.6786 50.7806 58.0814 51.2519 55.6023 50.1915C53.1231 49.1311 51.7064 46.8925 52.4148 45.243C53.1231 43.5936 55.7203 43.1223 58.1995 44.1827C60.6786 45.243 62.0953 47.4816 61.387 49.1311Z",
    fill: "#FCCE3A"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5062 48.8955C60.7978 50.6628 58.0825 51.1341 55.4853 50.0737C52.8881 49.0133 51.4714 46.6569 52.1798 44.8896C52.8881 43.1223 55.6034 42.651 58.2006 43.7114C60.7978 44.8896 62.2145 47.1282 61.5062 48.8955Z",
    fill: "url(#paint103_radial_704_7329)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5958 47.4816C53.4777 47.4816 53.3597 47.3638 53.3597 47.246C53.3597 47.1282 53.3597 47.0104 53.3597 47.0104C53.1236 46.5391 53.1236 45.95 53.2416 45.4787C53.7138 44.0648 55.7208 43.5936 57.8458 44.3005C59.0263 44.654 59.8527 45.3609 60.443 46.1856C60.5611 46.1856 60.6791 46.3034 60.7972 46.4213C60.9152 46.5391 60.7972 46.6569 60.7972 46.7747C60.9152 47.0104 60.9152 47.1282 60.9152 47.3638C61.0333 47.3638 61.0333 47.4816 61.0333 47.5995C61.0333 47.7173 61.0333 47.7173 60.9152 47.7173C60.9152 47.8351 60.9152 48.0707 60.7972 48.1886C60.3249 49.6024 58.318 50.0737 56.193 49.3668C55.0124 48.8955 54.068 48.1886 53.5958 47.4816Z",
    fill: "#FFFCE4"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5607 48.3063C59.9704 49.6024 57.9635 49.9558 55.9565 49.1311C53.9496 48.3063 52.769 46.539 53.3593 45.243C53.9496 43.947 55.9565 43.5935 57.9635 44.4183C59.9704 45.243 61.151 47.0103 60.5607 48.3063Z",
    fill: "url(#paint104_radial_704_7329)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3741 45.1253C59.263 45.95 60.3255 47.5995 59.8533 48.8955C59.7352 49.1312 59.6172 49.249 59.4991 49.3668C59.9714 49.1312 60.3255 48.7777 60.5616 48.4243C61.1519 47.1282 59.9714 45.3609 57.9644 44.5362C55.9575 43.7115 53.9505 44.0649 53.3602 45.3609C53.3602 45.4788 53.2422 45.5966 53.2422 45.5966C53.9505 44.654 55.7214 44.4184 57.3741 45.1253Z",
    fill: "url(#paint105_radial_704_7329)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7274 44.8896C59.4983 45.7143 60.6788 47.246 60.4427 48.4242V48.542C60.4427 48.542 60.4427 48.4242 60.5608 48.4242V48.3063C61.151 47.0103 59.9705 45.243 57.9635 44.4183C55.9566 43.5935 53.9497 43.947 53.3594 45.243V45.3608V45.4787C53.3594 45.4787 53.3594 45.3608 53.4774 45.3608C54.0677 44.3005 55.9566 44.0648 57.7274 44.8896Z",
    fill: "url(#paint106_linear_704_7329)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4427 47.5995C60.5608 47.953 60.5608 48.1886 60.4427 48.5421V48.6599C60.4427 48.6599 60.4427 48.5421 60.5608 48.5421V48.4243C61.151 47.1282 59.9705 45.3609 57.9635 44.5362C55.9566 43.7115 53.9497 44.0649 53.3594 45.3609V45.4788V45.5966C53.3594 45.5966 53.3594 45.4788 53.4774 45.4788C53.5955 45.3609 53.7135 45.1253 53.9497 45.0075C54.658 44.0649 56.4288 43.8293 58.0816 44.5362C59.4983 45.1253 60.5608 46.4213 60.4427 47.5995Z",
    fill: "url(#paint107_radial_704_7329)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7569 29.6907L23.1389 40.5301L7.08333 75.9941L0 62.916L14.7569 29.6907Z",
    fill: "url(#paint108_radial_704_7329)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1398 40.5301L32.112 43.8291L23.0217 32.754L14.7578 29.6907L23.1398 40.5301Z",
    fill: "#808080"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1118 43.8291L23.1395 40.5302L7.08398 75.9941L16.0562 79.1752L32.1118 43.8291Z",
    fill: "url(#paint109_radial_704_7329)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7578 29.6907C16.1745 31.458 17.5911 33.3431 19.0078 35.1104C20.4245 36.8777 21.8411 38.7628 23.2578 40.5301C24.7925 41.1192 26.2092 41.5905 27.7439 42.1796C29.2786 42.7687 30.6953 43.24 32.23 43.8291C30.6953 41.944 29.2786 40.1767 27.7439 38.2916C26.2092 36.4064 24.7925 34.6391 23.2578 32.754C21.8411 32.2827 20.5425 31.6936 19.1259 31.2223C17.5911 30.7511 16.1745 30.162 14.7578 29.6907Z",
    fill: "url(#paint110_radial_704_7329)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7565 29.6907L23.1385 40.5301L7.0829 75.9941L5.90234 73.7555C7.43707 74.4624 20.5412 47.1281 20.4232 41.3549C20.4232 35.9351 16.6454 31.6936 14.9926 31.458C14.0482 31.3402 13.694 32.0471 13.694 32.0471L14.7565 29.6907Z",
    fill: "url(#paint111_radial_704_7329)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26367 76.4654C16.5276 79.1753 33.4095 46.1856 27.6248 42.1797L32.1109 43.8292L16.1734 79.1753L8.26367 76.4654Z",
    fill: "url(#paint112_radial_704_7329)"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9523 27.4521C55.8411 28.866 56.1953 31.9293 54.7786 34.5213C53.2439 37.1134 50.4106 38.2916 48.2856 37.349C47.6953 37.1134 47.2231 36.8777 46.6328 36.5243L49.5842 31.458L52.5356 26.3917C53.0078 26.7452 53.48 27.0986 53.9523 27.4521Z",
    fill: "url(#paint113_linear_704_7329)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0701 28.0412C55.7229 29.2194 56.077 31.9293 54.7784 34.1679C53.5979 36.2886 51.4729 37.349 49.702 36.8777C48.5215 37.2312 47.459 37.1134 46.3965 36.5243C46.9868 36.8777 47.459 37.1134 48.0493 37.349C50.2923 38.2916 53.1257 37.1134 54.5423 34.5213C56.077 31.9293 55.7229 28.866 53.7159 27.4521C53.2437 27.0986 52.7715 26.7452 52.1812 26.3917C52.7715 26.7452 53.2437 27.2165 53.5979 27.8056C53.952 27.9234 53.952 27.9234 54.0701 28.0412Z",
    fill: "url(#paint114_radial_704_7329)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6537 26.6274C54.7787 27.9234 55.2509 31.1046 53.7162 33.8144C52.1815 36.5243 49.2301 37.7025 46.987 36.5243C44.862 35.2283 44.3898 32.0471 45.9245 29.3373C47.5773 26.6274 50.5287 25.4492 52.6537 26.6274Z",
    fill: "#FCCE3A"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4173 26.3917C54.6603 27.6878 55.2506 30.9867 53.5978 33.8144C51.9451 36.6421 48.7576 37.8203 46.5145 36.5243C44.2714 35.2283 43.6812 31.9293 45.3339 29.1016C46.8687 26.2739 50.0562 25.0957 52.4173 26.3917Z",
    fill: "url(#paint115_radial_704_7329)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0567 35.5818C50.0567 35.6996 49.9387 35.8174 49.7025 35.8174C49.5845 35.8174 49.4664 35.8174 49.3484 35.8174C48.64 35.9352 47.9317 35.9352 47.3414 35.5818C45.5706 34.757 44.9803 32.165 46.0428 29.8086C46.6331 28.5125 47.5775 27.57 48.64 27.2165C48.64 27.0987 48.7581 26.9809 48.9942 26.8631C49.1123 26.8631 49.3484 26.8631 49.4664 26.9809C49.7025 26.9809 49.9387 26.8631 50.1748 26.8631C50.1748 26.7452 50.2928 26.7452 50.5289 26.7452C50.647 26.7452 50.765 26.8631 50.765 26.8631C51.0012 26.8631 51.2373 26.9809 51.3553 27.0987C53.1262 27.9234 53.7164 30.5155 52.6539 32.8719C51.9456 34.1679 51.0012 35.1105 50.0567 35.5818Z",
    fill: "#FFFCE4"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5906 27.4521C53.2433 28.3947 53.5975 30.9867 52.4169 33.2253C51.1183 35.4639 48.7572 36.4065 46.9864 35.4639C45.3336 34.5213 44.9794 31.9293 46.16 29.6907C47.4586 27.4521 49.9378 26.5096 51.5906 27.4521Z",
    fill: "url(#paint116_radial_704_7329)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1044 30.5154C48.285 28.3947 50.528 27.5699 52.1808 28.3947C52.4169 28.5125 52.653 28.7481 52.7711 28.866C52.535 28.2769 52.0628 27.6878 51.4725 27.4521C49.8197 26.5096 47.3405 27.4521 46.0419 29.6907C44.7433 31.9293 45.0975 34.4035 46.8683 35.4639C46.9864 35.5817 47.1044 35.5817 47.2225 35.6995C46.278 34.4035 46.0419 32.2828 47.1044 30.5154Z",
    fill: "url(#paint117_radial_704_7329)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7513 29.9263C47.9319 27.9234 50.0569 26.9808 51.7097 27.5699C51.7097 27.5699 51.8277 27.5699 51.8277 27.6878L51.7097 27.5699C51.7097 27.5699 51.5916 27.5699 51.5916 27.4521C49.9388 26.5096 47.4597 27.4521 46.1611 29.6907C44.8625 31.9293 45.2166 34.4035 46.9875 35.4639C46.9875 35.4639 47.1055 35.4639 47.1055 35.5817C47.1055 35.5817 47.2236 35.5817 47.2236 35.6995L47.1055 35.5817C45.8069 34.2857 45.5708 31.9293 46.7513 29.9263Z",
    fill: "url(#paint118_linear_704_7329)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5291 27.4521C50.8833 27.4521 51.3555 27.4521 51.7097 27.5699C51.7097 27.5699 51.8277 27.5699 51.8277 27.6878L51.7097 27.5699C51.7097 27.5699 51.5916 27.5699 51.5916 27.4521C49.9388 26.5096 47.4597 27.4521 46.1611 29.6907C44.8625 31.9293 45.2166 34.4035 46.9875 35.4639C46.9875 35.4639 47.1055 35.4639 47.1055 35.5817C47.1055 35.5817 47.2236 35.5817 47.2236 35.6995L47.1055 35.5817C46.8694 35.4639 46.7513 35.2283 46.5152 34.9926C45.2166 33.9322 45.0986 31.8115 46.043 29.9263C47.2236 27.9234 48.9944 26.9808 50.5291 27.4521Z",
    fill: "url(#paint119_radial_704_7329)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3893 3.65243C46.6324 4.47718 47.8129 7.30486 47.1046 10.2504C46.3963 13.1959 44.0352 15.081 41.674 14.8454C41.0838 14.7275 40.4935 14.7275 39.7852 14.4919L41.2018 8.83653L42.6185 3.18115C43.3268 3.29897 43.9171 3.41679 44.3893 3.65243Z",
    fill: "url(#paint120_linear_704_7329)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7426 4.12376C46.6315 4.83068 47.694 7.30491 47.2218 9.77914C46.7496 12.1355 44.9787 13.785 43.2079 13.785C42.2635 14.3741 41.0829 14.6098 39.9023 14.3741C40.6107 14.4919 41.201 14.6098 41.7912 14.7276C44.1523 14.9632 46.5135 13.0781 47.2218 10.1326C47.9301 7.18709 46.7496 4.3594 44.5065 3.53466C43.9162 3.29902 43.326 3.1812 42.7357 2.94556C43.444 3.06338 44.0343 3.41684 44.5065 3.88812C44.5065 4.12376 44.6246 4.12376 44.7426 4.12376Z",
    fill: "url(#paint121_radial_704_7329)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9723 3.18115C45.4514 3.77025 46.75 6.71576 46.0417 9.77909C45.3334 12.8424 42.7361 14.8454 40.375 14.2563C37.8959 13.6672 36.5973 10.7217 37.3056 7.65833C38.0139 4.595 40.6111 2.59205 42.9723 3.18115Z",
    fill: "#FCCE3A"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6186 3.06341C45.2158 3.65251 46.6325 6.71584 45.9241 9.89699C45.2158 13.0781 42.5005 15.0811 39.9033 14.492C37.3061 13.9029 35.8894 10.8395 36.5977 7.6584C37.4241 4.47725 40.0213 2.47431 42.6186 3.06341Z",
    fill: "url(#paint122_radial_704_7329)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.973 12.6068C42.973 12.7246 42.8549 12.8424 42.7369 12.9602C42.6188 12.9602 42.5008 12.9602 42.3827 12.9602C41.7924 13.3137 41.0841 13.4315 40.3758 13.3137C38.3688 12.9602 37.0702 10.7216 37.5424 8.12959C37.7786 6.71575 38.3688 5.53755 39.3133 4.83062C39.3133 4.7128 39.3133 4.47716 39.5494 4.35934C39.6674 4.24152 39.9036 4.24152 40.0216 4.35934C40.2577 4.24152 40.4938 4.1237 40.7299 4.1237C40.7299 4.00588 40.848 4.00588 40.9661 3.88806C41.0841 3.88806 41.2022 3.88806 41.2022 4.00588C41.4383 4.00588 41.6744 4.00588 41.9105 4.00588C43.9174 4.35934 45.2161 6.59793 44.7438 9.18998C44.5077 10.7216 43.7994 11.782 42.973 12.6068Z",
    fill: "#FFFCE4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1473 4.35943C44.0362 4.83071 45.0987 7.18712 44.5084 9.66134C43.9182 12.1356 41.9112 13.7851 40.0223 13.3138C38.1334 12.8425 37.0709 10.4861 37.6612 8.01186C38.2515 5.41981 40.2584 3.88815 42.1473 4.35943Z",
    fill: "url(#paint123_radial_704_7329)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7226 8.48309C39.3129 6.12668 41.2018 4.59502 42.9726 5.0663C43.2087 5.18412 43.4448 5.18412 43.681 5.30194C43.2087 4.83066 42.7365 4.35938 42.0282 4.24155C40.1393 3.77027 38.1323 5.41976 37.5421 7.89398C36.9518 10.3682 38.0143 12.7246 39.9032 13.1959C40.0212 13.1959 40.1393 13.1959 40.3754 13.3137C38.9587 12.489 38.2504 10.486 38.7226 8.48309Z",
    fill: "url(#paint124_radial_704_7329)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2515 8.01178C38.8418 5.7732 40.4945 4.24153 42.2654 4.35935H42.1473C40.2584 3.88807 38.2515 5.53756 37.6612 8.01178C37.0709 10.486 38.1334 12.8424 40.0223 13.3137H40.1404H40.2584C40.2584 13.3137 40.1404 13.3137 40.1404 13.1959C38.6057 12.489 37.6612 10.3682 38.2515 8.01178Z",
    fill: "url(#paint125_linear_704_7329)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0844 4.59509C41.4386 4.47727 41.9108 4.35945 42.265 4.47727H42.1469C40.258 4.00599 38.2511 5.65548 37.6608 8.1297C37.0705 10.6039 38.133 12.9603 40.0219 13.4316H40.14H40.258C40.258 13.4316 40.14 13.4316 40.14 13.3138C39.9038 13.196 39.6677 13.0782 39.4316 12.8425C37.8969 12.1356 37.0705 10.1326 37.5427 8.01188C38.133 6.00894 39.5497 4.59509 41.0844 4.59509Z",
    fill: "url(#paint126_radial_704_7329)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0964 22.268C26.2075 23.6819 25.8534 26.7452 27.27 29.3372C28.8048 31.9293 31.6381 33.1075 33.7631 32.1649C34.3534 31.9293 34.8256 31.6937 35.4159 31.3402L32.4645 26.2739L29.7492 21.2076C29.0409 21.5611 28.5687 21.9146 28.0964 22.268Z",
    fill: "url(#paint127_linear_704_7329)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.979 22.8571C26.3262 24.0353 25.972 26.7452 27.2706 28.9838C28.4512 31.1045 30.5762 32.1649 32.347 31.6937C33.5276 32.0471 34.5901 31.9293 35.6526 31.3402C35.0623 31.6937 34.5901 31.9293 33.9998 32.1649C31.7567 33.1075 28.9234 31.9293 27.5067 29.3372C25.972 26.7452 26.3262 23.6819 28.3331 22.268C28.8054 21.9146 29.2776 21.5611 29.8679 21.2076C29.2776 21.5611 28.8054 22.0324 28.4512 22.6215C28.2151 22.7393 28.097 22.7393 27.979 22.8571Z",
    fill: "url(#paint128_radial_704_7329)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3952 21.4433C27.2702 22.7394 26.798 25.9205 28.3327 28.6304C29.8674 31.3402 32.9369 32.5184 35.0619 31.3402C37.1869 30.162 37.6591 26.8631 36.1244 24.1532C34.5897 21.4433 31.5202 20.1473 29.3952 21.4433Z",
    fill: "#FCCE3A"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7489 21.2077C27.5058 22.5037 26.9155 25.8026 28.5683 28.6303C30.2211 31.458 33.4086 32.6362 35.6517 31.3402C37.8947 30.0442 38.485 26.7452 36.8322 23.9175C35.1794 21.0898 31.9919 19.9116 29.7489 21.2077Z",
    fill: "url(#paint129_radial_704_7329)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1107 30.3977C32.1107 30.5155 32.2288 30.6333 32.4649 30.6333C32.583 30.6333 32.701 30.6333 32.8191 30.6333C33.5274 30.7511 34.2357 30.7511 34.826 30.3977C36.5969 29.5729 37.1871 26.9809 36.1246 24.6245C35.5344 23.3285 34.5899 22.3859 33.5274 22.0324C33.5274 21.9146 33.4094 21.7968 33.1732 21.679C33.0552 21.679 32.8191 21.679 32.701 21.7968C32.4649 21.7968 32.2288 21.679 31.9927 21.679C31.9927 21.5612 31.8746 21.5612 31.6385 21.5612C31.5205 21.5612 31.4024 21.679 31.4024 21.679C31.1663 21.679 30.9302 21.7968 30.8121 21.9146C29.0413 22.7394 28.451 25.3314 29.5135 27.6878C30.1038 28.9838 31.0482 29.9264 32.1107 30.3977Z",
    fill: "#FFFCE4"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4571 22.268C28.8043 23.2106 28.4501 25.8026 29.6307 28.0412C30.9293 30.2798 33.2904 31.2223 35.0613 30.2798C36.714 29.3372 37.0682 26.7452 35.8876 24.5066C34.589 22.268 32.2279 21.2076 30.4571 22.268Z",
    fill: "url(#paint130_radial_704_7329)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.944 25.3314C33.7635 23.2106 31.5204 22.3859 29.8676 23.2106C29.6315 23.3284 29.3954 23.5641 29.2773 23.6819C29.5135 23.0928 29.9857 22.5037 30.576 22.268C32.2287 21.3255 34.7079 22.268 36.0065 24.5066C37.3051 26.7452 36.951 29.2194 35.1801 30.2798C35.0621 30.3976 34.944 30.3976 34.826 30.5155C35.8885 29.2194 36.0065 27.0987 34.944 25.3314Z",
    fill: "url(#paint131_radial_704_7329)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2971 24.7423C34.1165 22.7393 31.9915 21.7968 30.3388 22.3859C30.3388 22.3859 30.2207 22.3859 30.2207 22.5037L30.3388 22.3859C30.3388 22.3859 30.4568 22.3859 30.4568 22.268C32.1096 21.3255 34.5888 22.268 35.8874 24.5066C37.186 26.7452 36.8318 29.2194 35.061 30.2798C35.061 30.2798 34.9429 30.2798 34.9429 30.3976C34.9429 30.3976 34.8249 30.3976 34.8249 30.5155L34.9429 30.3976C36.2415 29.1016 36.4776 26.7452 35.2971 24.7423Z",
    fill: "url(#paint132_linear_704_7329)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5193 22.1502C31.1651 22.1502 30.6929 22.1502 30.3388 22.2681C30.3388 22.2681 30.2207 22.2681 30.2207 22.3859L30.3388 22.2681C30.3388 22.2681 30.4568 22.2681 30.4568 22.1502C32.1096 21.2077 34.5888 22.1502 35.8874 24.3888C37.186 26.6274 36.8318 29.1016 35.061 30.162C35.061 30.162 34.9429 30.162 34.9429 30.2798C34.9429 30.2798 34.8249 30.2798 34.8249 30.3977L34.9429 30.2798C35.179 30.162 35.2971 29.9264 35.5332 29.6907C36.8318 28.6304 36.9499 26.5096 36.0054 24.6245C34.8249 22.7393 33.054 21.7968 31.5193 22.1502Z",
    fill: "url(#paint133_radial_704_7329)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8326 48.0391) scale(38.2031 38.127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4677 20.056) scale(68.1288 67.9931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#730000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.1687 59.013) scale(22.328 22.2835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#F9F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6583,
    stopColor: "#EADADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7556,
    stopColor: "#D1ADB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8712,
    stopColor: "#AE7083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822341"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3836 45.5725) scale(45.461 45.3704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    stopColor: "#F9F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6583,
    stopColor: "#EADADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7556,
    stopColor: "#D1ADB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8712,
    stopColor: "#AE7083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822341"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.98173 74.4478) scale(35.2501 35.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#FAF6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#EDDEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7325,
    stopColor: "#D7B7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8359,
    stopColor: "#B98270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9519,
    stopColor: "#933E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.2742 72.1237) scale(30.219 30.1588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#FAF6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#EDDEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7325,
    stopColor: "#D7B7AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8359,
    stopColor: "#B98270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9519,
    stopColor: "#933E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4651 61.3001) scale(47.3248 47.2305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#730000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60E10"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.391 57.5268) scale(33.2525 33.1862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_704_7329",
    x1: 13.3946,
    y1: 45.5934,
    x2: 68.0502,
    y2: 45.5934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_704_7329",
    x1: 23.9,
    y1: 74.5862,
    x2: 23.9,
    y2: 50.8442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A0C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_704_7329",
    x1: 29.889,
    y1: 47.1102,
    x2: 39.2702,
    y2: 43.4142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0431 43.8987) rotate(34.0521) scale(4.18576 4.50366)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4339 42.4415) rotate(34.0521) scale(6.07481 6.53617)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4142 39.1079) rotate(34.0521) scale(7.78981 8.38142)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1273 37.2352) rotate(34.0521) scale(9.51837 10.2413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5008 44.5732) rotate(34.0521) scale(5.49904 5.91667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_704_7329",
    x1: 29.6387,
    y1: 43.4621,
    x2: 36.853,
    y2: 40.6199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4096 44.8138) rotate(34.0521) scale(5.33094 5.7358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_704_7329",
    x1: 45.5661,
    y1: 46.624,
    x2: 52.3977,
    y2: 39.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.8061 41.4951) rotate(8.29883) scale(4.18805 4.501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7239 40.8813) rotate(8.29884) scale(6.07817 6.53236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0535 37.0199) rotate(8.29884) scale(7.79415 8.37656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.0775 35.8926) rotate(8.29884) scale(9.5237 10.2353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6131 42.3374) rotate(8.29883) scale(5.50207 5.91321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_704_7329",
    x1: 43.7511,
    y1: 43.4473,
    x2: 49.0048,
    y2: 37.7527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6363 42.5933) rotate(8.29884) scale(5.33388 5.73245)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_704_7329",
    x1: 37.1123,
    y1: 46.1636,
    x2: 37.1123,
    y2: 41.1534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC95E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_704_7329",
    x1: 36.2229,
    y1: 42.2205,
    x2: 44.0106,
    y2: 48.6166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5452 45.1436) rotate(94.9197) scale(4.18006 4.50997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0357 43.0314) rotate(94.9197) scale(6.06642 6.5452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9185 43.1307) rotate(94.9197) scale(7.77896 8.3929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9274 41.0956) rotate(94.9197) scale(9.50515 10.2553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6908 45.0008) rotate(94.9197) scale(5.49141 5.9248)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_704_7329",
    x1: 39.2914,
    y1: 40.2235,
    x2: 45.2803,
    y2: 45.1423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.437 45.0395) rotate(94.9197) scale(5.32353 5.74367)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_704_7329",
    x1: 45.8564,
    y1: 47.0606,
    x2: 45.0463,
    y2: 42.1266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC95E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_704_7329",
    x1: 46.366,
    y1: 50.7166,
    x2: 53.1839,
    y2: 43.2991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.5966 45.582) rotate(8.20007) scale(4.18823 4.50086)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5125 44.9718) rotate(8.20007) scale(6.07842 6.53215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8363 41.1099) rotate(8.20007) scale(7.79456 8.37638)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8583 39.9861) rotate(8.20007) scale(9.52417 10.2351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.4049 46.4249) rotate(8.20007) scale(5.50248 5.91321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_704_7329",
    x1: 44.5465,
    y1: 47.5436,
    x2: 49.7895,
    y2: 41.8395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.4297 46.6807) rotate(8.20007) scale(5.33437 5.73256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_704_7329",
    x1: 29.8278,
    y1: 49.569,
    x2: 39.6162,
    y2: 47.1429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3598 47.0632) rotate(41.6203) scale(4.18469 4.50481)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9581 45.4071) rotate(41.6204) scale(6.07334 6.53795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3606 42.363) rotate(41.6204) scale(7.78788 8.38364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3319 40.3373) rotate(41.6204) scale(9.51598 10.2439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7337 47.6608) rotate(41.6204) scale(5.49769 5.91826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_704_7329",
    x1: 30.0614,
    y1: 45.9199,
    x2: 37.5888,
    y2: 44.0541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6123 47.8874) rotate(41.6204) scale(5.32973 5.73745)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_704_7329",
    x1: 34.0939,
    y1: 48.3579,
    x2: 43.723,
    y2: 48.3579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17F4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_704_7329",
    x1: 38.1678,
    y1: 50.8919,
    x2: 47.6491,
    y2: 47.4597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4097 47.8253) rotate(35.647) scale(4.18531 4.50409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.8419 46.3239) rotate(35.647) scale(6.07404 6.53668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.9148 43.0467) rotate(35.647) scale(7.78883 8.38208)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6797 41.139) rotate(35.647) scale(9.51729 10.2422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.8491 48.4843) rotate(35.6469) scale(5.4983 5.91709)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_704_7329",
    x1: 38.0208,
    y1: 47.238,
    x2: 45.3121,
    y2: 44.5986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.752 48.7223) rotate(35.647) scale(5.33011 5.73609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_704_7329",
    x1: 57.4847,
    y1: 50.9685,
    x2: 65.9364,
    y2: 45.4756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0254 45.6881) rotate(22.5609) scale(6.07661 6.53404)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.299 42.0272) rotate(22.5609) scale(7.7922 8.37878)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.6637 40.4484) rotate(22.5609) scale(9.52126 10.238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.4953 47.5647) rotate(22.5609) scale(5.50074 5.91482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_704_7329",
    x1: 56.5098,
    y1: 47.4435,
    x2: 63.0092,
    y2: 43.2193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.4547 47.8185) rotate(22.5609) scale(5.33248 5.7339)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_704_7329",
    x1: 28.0297,
    y1: 55.5419,
    x2: 38.9421,
    y2: 55.5354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4913 54.3407) rotate(55.4822) scale(4.5256 4.87648)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.4491 52.2384) rotate(55.4822) scale(6.56797 7.0772)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7641 49.6622) rotate(55.4822) scale(8.42212 9.07512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2085 47.2682) rotate(55.4822) scale(10.291 11.0889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6791 54.8064) rotate(55.4822) scale(5.94546 6.40643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_704_7329",
    x1: 29.2222,
    y1: 51.7692,
    x2: 37.6142,
    y2: 51.7643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.492 55.0131) rotate(55.4822) scale(5.76362 6.21049)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9802 47.1573) rotate(55.4822) scale(7.66417 8.2584)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#FAEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#EDE262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#D6CC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#B7AE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#8E873B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#5C5826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#23210E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_704_7329",
    x1: 35.0228,
    y1: 52.9678,
    x2: 45.1086,
    y2: 52.9618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0317 49.9145) rotate(55.4822) scale(6.07038 6.54104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0955 47.5335) rotate(55.4822) scale(7.78408 8.38761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.5832 45.3209) rotate(55.4822) scale(9.51134 10.2488)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.2445 52.2881) rotate(55.4822) scale(5.49501 5.92105)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_704_7329",
    x1: 36.125,
    y1: 49.481,
    x2: 43.8812,
    y2: 49.4764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0712 52.4791) rotate(55.4822) scale(5.32703 5.74005)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_704_7329",
    x1: 27.8029,
    y1: 53.5805,
    x2: 37.645,
    y2: 51.3811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.0293 49.515) rotate(42.9409) scale(6.07294 6.53772)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5016 46.527) rotate(42.9409) scale(7.78769 8.38371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5209 44.4782) rotate(42.9409) scale(9.5158 10.2441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.753 51.7854) rotate(42.9409) scale(5.4977 5.91846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_704_7329",
    x1: 28.1224,
    y1: 49.9378,
    x2: 35.6911,
    y2: 48.2464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6255 52.009) rotate(42.9409) scale(5.32964 5.73753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_704_7329",
    x1: 42.12,
    y1: 50.9167,
    x2: 51.749,
    y2: 50.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17F4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_704_7329",
    x1: 43.4227,
    y1: 50.1067,
    x2: 53.4307,
    y2: 51.3538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7732 47.6968) rotate(62.6118) scale(6.0689 6.5426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1087 45.7133) rotate(62.6118) scale(7.78215 8.38958)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8747 43.4542) rotate(62.6118) scale(9.50906 10.2513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6895 50.0782) rotate(62.6118) scale(5.49357 5.92236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_704_7329",
    x1: 44.9505,
    y1: 46.7833,
    x2: 52.6469,
    y2: 47.7423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.4938 50.2466) rotate(62.6118) scale(5.32564 5.74132)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_704_7329",
    x1: 53.8198,
    y1: 47.802,
    x2: 63.4488,
    y2: 47.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17F4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC95E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_704_7329",
    x1: 49.8702,
    y1: 49.1607,
    x2: 59.4993,
    y2: 49.1607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17F4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_704_7329",
    x1: 51.3778,
    y1: 46.9172,
    x2: 60.631,
    y2: 50.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.1897 46.1003) rotate(78.9099) scale(6.06672 6.54473)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.9497 45.1292) rotate(78.9099) scale(7.77938 8.39233)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3586 42.8954) rotate(78.9099) scale(9.50568 10.2547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.441 48.3623) rotate(78.9099) scale(5.49167 5.92437)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_704_7329",
    x1: 53.7773,
    y1: 44.1541,
    x2: 60.8932,
    y2: 47.2338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.2061 48.4694) rotate(78.9099) scale(5.32378 5.74325)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3504 30.2362) scale(47.7679 47.6727)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.291185 39.1562) scale(43.1994 43.1133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#730000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5686 36.4293) scale(24.0935 24.0455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F23559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C40000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-9.10618 46.1378) scale(41.3296 41.2472)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0408 56.2503) scale(45.1055 45.0156)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A0C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_704_7329",
    x1: 49.1411,
    y1: 38.0898,
    x2: 54.9944,
    y2: 27.9313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3991 30.9397) scale(8.00098 7.98504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3294 26.2108) scale(10.2599 10.2394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.3776 25.1957) scale(12.5364 12.5115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3679 32.3677) scale(7.24271 7.22828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_704_7329",
    x1: 45.6033,
    y1: 34.5681,
    x2: 50.1044,
    y2: 26.7562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.4977 32.6731) scale(7.02136 7.00736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_704_7329",
    x1: 42.837,
    y1: 15.196,
    x2: 45.5833,
    y2: 3.80279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0993 8.54696) rotate(-16.3906) scale(7.99976 7.98636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7347 4.31275) rotate(-16.3906) scale(10.2581 10.241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6171 4.17198) rotate(-16.3906) scale(12.5345 12.5135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3526 9.07908) rotate(-16.3906) scale(7.24162 7.22949)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_704_7329",
    x1: 38.4465,
    y1: 12.8164,
    x2: 40.5585,
    y2: 4.05493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.5632 9.33578) rotate(-16.3906) scale(7.02018 7.00842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_704_7329",
    x1: 32.9305,
    y1: 32.8836,
    x2: 27.0771,
    y2: 22.7252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E86F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6728 25.7336) rotate(180) scale(8.00098 7.98504)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7414 21.0046) rotate(180) scale(10.2599 10.2394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9C0D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6928 19.9896) rotate(180) scale(12.5364 12.5115)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.7035 27.1616) rotate(180) scale(7.24271 7.22828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6851,
    stopColor: "#FFE2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_704_7329",
    x1: 36.4681,
    y1: 29.3619,
    x2: 31.9669,
    y2: 21.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC940D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86F0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_704_7329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5737 27.467) rotate(180) scale(7.02135 7.00736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#E6DDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09444"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_704_7329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSta5);
export default __webpack_public_path__ + "static/media/sta_5.1d7343796e7c6facb39d0009e7911335.svg";
export { ForwardRef as ReactComponent };